export default __webpack_public_path__ + "static/media/square-grey-dots.1a324c27.svg";